export default __webpack_public_path__ + "static/media/apartments_points.c8b83397.geojson";